import { Tabs } from 'antd';
import React from 'react';
import { useSearchParams } from 'react-router';

import GiftRegistriesContainer from './gift-registries-container';
import GiftRegistryRefundsContainer from './gift-registry-refunds-container';

const TAB_PARAM = 'tab';
const DEFAULT_TAB = 'registries';

function GiftRegistryContainer(): React.ReactElement {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeKey = searchParams.get(TAB_PARAM) ?? DEFAULT_TAB;

  return (
    <Tabs
      activeKey={activeKey}
      destroyOnHidden
      onChange={(key): void => {
        setSearchParams((params) => {
          params.set(TAB_PARAM, key);
          return params;
        });
      }}
      items={[
        {
          key: 'registries',
          label: 'Registries',
          children: <GiftRegistriesContainer />,
        },
        {
          key: 'refunds',
          label: 'Refunds',
          children: <GiftRegistryRefundsContainer />,
        },
      ]}
    />
  );
}

export default GiftRegistryContainer;
